(function () {
	function initProductCardSliders(root) {
		const scope = root || document;
		const sliders = scope.querySelectorAll(".product-card-js");

		sliders.forEach((slider) => {
			// Skip cards already initialised (re-runs on section load / facet render).
			if (slider.swiper) return;

			const nextEl = slider.querySelector(
				".product-button-group.button-next .swiper-button-next"
			);
			const prevEl = slider.querySelector(
				".product-button-group.button-prev .swiper-button-prev"
			);
			const paginationEl = slider.querySelector(
				".product-pagination .swiper-pagination"
			);

			new Swiper(slider, {
				pagination: paginationEl
					? {
							el: paginationEl,
							clickable: true,
					  }
					: false,
				navigation:
					nextEl && prevEl
						? {
								nextEl: nextEl,
								prevEl: prevEl,
						  }
						: false,
				watchOverflow: true,
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					},
				},
			});
		});
	}

	// Shared entry point so global.js / facets.js reuse this config
	// instead of duplicating (and de-syncing) it.
	window.initProductCardSliders = initProductCardSliders;

	initProductCardSliders();

	document.addEventListener("shopify:section:load", function (event) {
		initProductCardSliders(event.target || document);
	});
})();
